import * as React from 'react'
import PropTypes from 'prop-types';

class HighLighter extends React.Component {

    constructor(props) {
        super(props);
    }

    renderName(name) {

        var splitPattern = this.props.searchTerm != null ? new RegExp("(" + this.props.searchTerm + ")", "i") : '';
        var miniWords = name?.split(splitPattern);

        var html = [];

        _.each(miniWords, (miniWord) => {
            if (this.props.searchTerm != null && miniWord.toLowerCase() == this.props.searchTerm.toLowerCase()) {
                html.push(<span className={this.props.highlightedItemClass}>{miniWord}</span>)
            } else {
                html.push(<span className={this.props.itemClass}>{miniWord}</span>)
            }
        });

        return <span> {html}</span>;
    }

    render() {
        const { wrapperClass } = this.props;
        
        return (
            <div className={wrapperClass}>{this.renderName(this.props.text)}</div>
        )
    }
}

HighLighter.defaultProps = {
    searchTerm: null,
    text: null,
    wrapperClass: null,
    highlightedItemClass: null,
    itemClass: null,
};

HighLighter.propTypes = {
    searchTerm: PropTypes.string,
    text: PropTypes.string,
    wrapperClass: PropTypes.string,
    highlightedItemClass: PropTypes.string,
    itemClass: PropTypes.string,
}

export default HighLighter;